import React from 'react'

const EmployeeAttendance = () => {
  return (
    <div>EmployeeAttendance</div>
  )
}

export default EmployeeAttendance